module.exports = __webpack_public_path__ + "img/图层 3.51bba50a.png";